import '../../../harleys-pipeline/packages/design-system/src/styles/loading.css';
interface Props { message?: string; error?: string | null; }
export function SafetyLoadingPanel({ message, error }: Props) {
  return <section className="pipeline-loading" role={error ? 'alert' : 'status'} aria-atomic="true">
    <div className="pipeline-loading__mark" aria-hidden="true">
      {error ? <span className="pipeline-loading__error">!</span> : <img src="/icons/Take5_PipeLine_Colour_Icon_Small.png" alt="" />}
    </div>
    <p className="pipeline-loading__context">PipeLine · Take 5</p>
    <h1 className="pipeline-loading__title">{error ? 'Take 5 couldn’t open' : message || 'Opening Take 5'}</h1>
    <p className="pipeline-loading__message">{error || (message?.startsWith('Signing') ? 'Connecting to your workplace account.' : message?.startsWith('Loading') ? 'Loading your assigned jobs and safety checklist.' : 'Keep this screen open until saving is complete.')}</p>
    {!error && <div className="pipeline-loading__track" aria-hidden="true"><span /></div>}
    {error && <div className="pipeline-loading__actions"><button type="button" className="pipeline-loading__retry" onClick={() => window.location.reload()}>Try again</button></div>}
  </section>;
}
export function SplashScreen({ message = 'Signing you in', error = null }: Props) {
  return <main className="pipeline-loading-screen"><SafetyLoadingPanel message={message} error={error} /></main>;
}
